import React, { useState, useEffect } from 'react';

import './Message.scss';
import { useMessagesContext } from '../MessagesContext';
import { useTypewriter } from '../useTypewriter';

interface MessageProps {
  text?: string;
  isUser: boolean;
  choices?: string[];
  onChoiceSelect?: (choice: string) => void;
}

const Message = ({
  text = '',
  isUser,
  choices,
  onChoiceSelect,
}: MessageProps): React.ReactElement => {
  const [showChoices, setShowChoices] = useState(false);
  const { addMessage } = useMessagesContext();

  // Use typewriter effect only for system messages
  const displayedText = isUser ? text : useTypewriter(text);

  // Delay displaying the choices by 1.5 seconds
  useEffect(() => {
    if (choices) {
      const timeoutId = setTimeout(() => {
        setShowChoices(true);
      }, 1500);

      return () => clearTimeout(timeoutId);
    }
  }, [choices]);

  const handleChoiceSelect = (choice: string) => {
    // Add user's choice as a message
    addMessage({ id: Date.now(), text: choice, isUser: true });

    // Trigger AgentExecution with the selected choice
    addMessage({
      id: Date.now() + 1,
      isUser: false,
      agentExecution: true,
      userInput: choice,
    });

    // Call the onChoiceSelect callback if provided
    if (onChoiceSelect) {
      onChoiceSelect(choice);
    }
  };

  return (
    <div className={`message-bubble ${isUser ? 'user-message' : 'system-message'}`}>
      {displayedText}
      {choices && showChoices && (
        <div className='message-choices'>
          {choices.map((choice, idx) => (
            <button key={idx} className='choice-button' onClick={() => handleChoiceSelect(choice)}>
              {choice}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Message;
